import useAbortController from 'hooks/useAbortController';
import {
  getConnectCardUrl,
  getConnectPageUrl,
} from 'modules/connect-card/utils';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getConnectCards,
  getConnectPoints,
} from 'services/connect-card.service';
import { getRedirects } from 'services/redirects.service';
import { getVideoPages } from 'services/videoPages.service';
import { withHttp } from 'utils';

const useLinkData = (type, query) => {
  const account = useSelector((state) => state.settings.account);
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const { cancelPreviousRequest, newAbortSignal, isCancel } =
    useAbortController();
  useEffect(() => {
    setData();
    setError();
    setLoading(true);
    switch (type) {
      case 'connect_card': {
        getConnectCards({ account_id: account.account_id })
          .then((res) => {
            setData(
              res.map((item) => ({
                id: item.id,
                label: item.card_name,
                type: 'connect_card',
                url: getConnectCardUrl(item) + '/{CONTACT_HASH}',
              })),
            );
          })
          .catch((e) => {
            setError(e.message);
          })
          .finally(() => setLoading(false));
        break;
      }
      case 'connect_page': {
        getConnectPoints({ account_id: account.id })
          .then((resp) => {
            setData(
              resp.map((item) => ({
                id: item.id,
                label: item.collection_title,
                type: 'connect_page',
                url: getConnectPageUrl(item),
              })),
            );
          })
          .catch((e) => setError(e.message))
          .finally(() => setLoading(false));
        break;
      }
      case 'short_url': {
        cancelPreviousRequest();
        getRedirects({
          account_id: account.id,
          search: query,
          signal: newAbortSignal(),
        })
          .then((resp) => {
            setData(
              resp.map((item) => ({
                id: item.redir_id,
                label: item.redir_name,
                type: 'short_url',
                url:
                  item.redirect?.qr_code_text ||
                  `${withHttp(item.redir_domain)}/${item.redir_url_short}`,
              })),
            );
          })
          .catch((e) => {
            if (isCancel(e)) return;
            setError(e.message);
          })
          .finally(() => setLoading(false));
        break;
      }
      case 'pages': {
        getVideoPages({ account_id: account.id })
          .then((resp) => {
            setData(
              resp.map((item) => ({
                id: item.id,
                label: item.headline,
                type: 'pages',
                url: item.redirect?.qr_code_text,
              })),
            );
          })
          .catch((e) => setError(e.message))
          .finally(() => setLoading(false));
      }
    }
  }, [type, query]);

  return {
    error,
    loading,
    data,
  };
};

export default useLinkData;
